import { render, staticRenderFns } from "./PaniereInCart.vue?vue&type=template&id=3ac7722f&scoped=true"
import script from "./PaniereInCart.vue?vue&type=script&lang=js"
export * from "./PaniereInCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac7722f",
  null
  
)

export default component.exports